import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_info-pdp_eco_friendly_info_show_details-click';
/**
 * User clicks the &quot;Show details&quot; button in Eco-friendly section of product details page.
 */
export function trackProductInfoPdpEcoFriendlyInfoShowDetailsClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
